// remove expiring tokens from non development env
export const getImageUrl = url => {
  if (!url) return null;
  return url.split('?')[0];
};
